import * as React from 'react';

import { ProjectPropertyType } from 'src/constants/project';
import { useDiagram } from 'src/containers/ProjectDiagram/hooks/useDiagramValue';
import { commitDiagramModel } from 'src/containers/ProjectDiagram/utils/commitDiagramModel';
import { setPropertyType } from 'src/containers/ProjectDiagram/utils/propertyType/setPropertyType';

export const useUpdatePropertyType = (iri?: string) => {
  const diagram = useDiagram();

  return React.useCallback(
    (newPropertyType: ProjectPropertyType) => {
      if (!diagram || !iri) {
        return;
      }
      commitDiagramModel(diagram, setPropertyType(iri, newPropertyType));
    },
    [diagram, iri]
  );
};
